import { Flex } from "antd";
import DoorOpenImg from "../../../../assets/images/home/DoorOpen.svg";
import LineImag from "../../../../assets/images/home/Group 97557.png";
import { howToUse } from "../constants";

export default function HowToUse() {
  return (
    <section className="container mini-container py-12 lg:py-24">
      {/* Center the div horizontally */}
      <div className="w-16 h-20 mx-auto flex justify-center items-center mb-2">
        <img
          src={DoorOpenImg}
          alt="door_open_img"
          className="object-contain max-w-full max-h-full"
        />
      </div>

      <div className="text-center justify-start text-theme-primary text-4xl lg:text-5xl font-semibold mb-2">
        কিভাবে শুরু করবেন?
      </div>

      <div className="text-center justify-start text-theme-primary text-lg lg:text-xl font-medium">
        ধাপ সমূহ
      </div>

      <div className="container mt-12">
        <div className="relative bg-theme-white-900 rounded-2xl shadow-md px-8 py-5">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4 text-center relative">
            {howToUse.map((el) => (
              <article key={el.title}>
                <Flex justify="center">
                  <img className="relative z-10" src={el.icon} alt="" />
                </Flex>
                <h3 className="text-theme-primary text-base lg:text-lg font-semibold mt-5">
                  {el.title}
                </h3>
                <p className="text-center justify-start text-theme-slate-700 text-sm lg:text-base font-normal mt-2">
                  {el.description}
                </p>
              </article>
            ))}
            <img
              className="absolute top-5 left-2/4 -translate-x-2/4 w-[77%] hidden lg:block"
              src={LineImag}
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
}
